









import { Component, Mixins, Prop } from "vue-property-decorator"

import { ImageMixin, SpacingMixin, WidgetMixin } from "./mixins"

@Component
export default class WImage extends Mixins(WidgetMixin, ImageMixin, SpacingMixin) {
  @Prop({ type: Boolean, default: false })
  fluid!: boolean;

  @Prop({ type: Boolean, default: false })
  fluidGrow!: boolean;

  // top | right | bottom | left | circle | 0
  @Prop({ type: [Boolean, String] })
  rounded?: boolean | string;
}
